<template>
  <div class="versionUpdateNotify" />
</template>
<script>
import { getApps, initializeApp } from 'firebase/app'
import { getDatabase, ref, onValue } from 'firebase/database'
export default {
  mounted () {
    const _kingetcareFb =
      getApps().filter(x => x.name === 'kingnetcare').length === 1
        ? getApps().filter(x => x.name === 'kingnetcare')[0]
        : initializeApp(firebaseConfig, 'kingnetcare')

    // set 成功 get 卻失敗 -> 此版本是用 once 而非 get

    // set
    // _kingetcareFb
    //   .database()
    //   .ref(`Management_Web/versionUpdate/dev/open`)
    //   .set(true);

    // once
    // _kingetcareFb
    //   .database()
    //   .ref(`Management_Web/versionUpdate/dev/newVersion`)
    //   .once("value")
    //   .then(result => {
    //     console.log("newVersion", result.val());
    // });

    const env = process.env.VUE_APP_ENV
    console.log('env', env)
    let versionUpdateNotification = null
    const database = getDatabase(_kingetcareFb)
    const reference = ref(database, `Management_Web/versionUpdate/${env}/`)
    onValue(reference, snapshot => {
      const currentVersion = `${process.env.VUE_APP_VERSION}.${process.env.VUE_APP_VERSION_DATE}`
      console.log('currentVersion', currentVersion)
      const { newVersion, open } = snapshot.val()
      console.log('newVersion', newVersion)
      const versionCompare = this.$versionCompare(currentVersion, newVersion)
      console.log('versionCompare', versionCompare)
      //   如果之前有出現過的話就關閉之前的
      versionUpdateNotification && versionUpdateNotification.close()
      switch (versionCompare) {
        case -1:
          console.log('version', '該更新囉！')
          if (open) {
            console.log('version', '顯示更新提醒')
            versionUpdateNotification = this.$notify({
              title: '版本更新提示',
              message: '檢測到系統當前版本已更新，請刷新重新載入頁面。',
              type: 'warning',
              showClose: true,
              duration: 0
            })
          } else {
            console.log('version', '不顯示更新提醒')
          }
          break
        case 1:
          console.log('version', '此版本正在開發中')
          break
        default:
          console.log('version', '此版本已為最新版本')
          break
      }
    })
  }
}
</script>
